export default {
  getHistory(val) {
    if (val !== null && val.length > 0) {
      return val.split(`,`);
    }
    return [];
  },
  getAccountStatus(val) {
    if (val === `1`) {
      return `פעיל`;
    }
    return `לא פעיל`;
  },

  getConfig(val) {
    if (val !== null && val !== ``) {
      return val.split(`,`);
    }
    return [];
  },

  getMyVideos(val) {
    if (val !== null && val.length > 0) {
      return val.split(`,`);
    }
    return [];
  },

  getSeriesHistory(val) {
    if (Array.isArray(val)) {
      return val;
    }
    return [];
  },

  formatDate(d) {
    const date = new Date(d.replace(` `, `T`));
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  },

  hasToken(token) {
    if (token.length === 0 || token === "no-token-canceled") {
      return false;
    }
    return true;
  },

  shuffleArray(array) {
    // eslint-disable-next-line
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      // eslint-disable-next-line
      array[i] = array[j];
      // eslint-disable-next-line
      array[j] = temp;
    }
    return array;
  },

  filterByPrefs(state, getters) {
    const output = state.videos.filter(video => {
      if (
        getters.xpSelected.id === 1 &&
        video.videoLvl === `1` &&
        getters.currentSelected.indexOf(video.current) > -1 &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }

      if (
        getters.xpSelected.id === 3 &&
        video.videoLvl === `1` &&
        getters.currentSelected.indexOf(video.current) > -1 &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }

      if (
        getters.xpSelected.id === 2 &&
        parseInt(video.videoLvl, 10) < 3 &&
        parseInt(video.videoLvl, 10) > 0 &&
        getters.currentSelected.indexOf(video.current) > -1 &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }

      if (
        getters.xpSelected.id === 4 &&
        parseInt(video.videoLvl, 10) > 1 &&
        getters.currentSelected.indexOf(video.current) > -1 &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }
      return false;
    });

    return output;
  },

  filterByPrefsWide(state, getters) {
    const output = state.videos.filter(video => {
      if (parseInt(video.videoRating, 10) < 7) {
        return false;
      }

      if (
        getters.xpSelected.id === 1 &&
        video.videoLvl === `1` &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }

      if (
        getters.xpSelected.id === 3 &&
        video.videoLvl === `1` &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }

      if (
        getters.xpSelected.id === 2 &&
        parseInt(video.videoLvl, 10) < 3 &&
        parseInt(video.videoLvl, 10) > 0 &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }

      if (
        getters.xpSelected.id === 4 &&
        parseInt(video.videoLvl, 10) > 1 &&
        state.user.history.indexOf(video.id) === -1
      ) {
        return true;
      }
      return false;
    });

    return output;
  },

  inTeacherOptions(teacher, options) {
    let inArray = false;

    options.forEach(t => {
      if (t.id === teacher.id) {
        inArray = true;
      }
    });
    return inArray;
  },

  getRecommended(state, getters, precision) {
    let output = [];
    state.videos.forEach(video => {
      const score = this.getScore(video, getters);
      if (score > precision) {
        video.score = score;
        output.push(video);
      }
    });

    output = output.sort((a, b) => {
      return b.score - a.score;
    });

    if (output.length > 100) {
      return output.slice(0, 100);
    }
    return output;
  },

  getScore(video, getters) {
    const teachers = getters.topTeachers;
    const styles = getters.topStyles;
    const dur = parseInt(getters.averageDuration, 10);
    const level = getters.averageLevel;
    const focus = getters.averageFocus;

    let score = 0;

    score += this.getPrefScore(video, getters.prefs);

    if (teachers.indexOf(video.videoTeacher) > -1) {
      score += 3;
    }

    if (styles.indexOf(video.current) > -1) {
      score += 3;
    }
    if (
      dur > parseInt(video.videoDuration, 10) - 10 &&
      dur < parseInt(video.videoDuration, 10) + 10
    ) {
      score += 3;
    }

    const l = parseInt(video.videoLvl, 10);

    if (level > 2 && l > 1) {
      score += 2;
    }
    if (level > 2 && l > 2) {
      score += 2;
    }

    const flist = getters.videoFocus(video);
    let f = 0;
    if (flist.length > 1) {
      f =
        flist.reduce((a, b) => {
          if (a.rank) {
            return parseInt(a.rank, 10) + parseInt(b.rank, 10);
          }
          return a + parseInt(b.rank, 10);
        }) / flist.length;
    } else {
      if (flist.length > 0) {
        f = parseInt(flist[0].rank, 10);
      }
    }
    if (focus >= f - 1 && focus <= f + 1) {
      score += 2;
    }

    if (getters.inHistory(video.id)) {
      score -= 5;
    }
    return score;
  },

  getPrefScore(video, prefs) {
    let score = 0;
    // focus
    if (video.focus && prefs.focus) {
      const vf = video.focus.split("||");
      prefs.focus.forEach(item => {
        item.focusId.forEach(fid => {
          if (vf.includes(`${fid}`)) {
            score += 1;
          }
        });
      });
    }

    // metastyles
    if (video.current && prefs.metaStyle) {
      let styles = [];
      prefs.metaStyle.forEach(item => {
        styles = [...styles, ...item.includes];
      });

      if (styles.includes(video.current)) {
        score += 1;
      }
    }

    // levels
    if (video.videoLvl && prefs.level) {
      if (`${prefs.level.id}` === video.videoLvl) {
        score += 1;
      }
    }

    // tempo
    if (video.tempo && prefs.tempo) {
      if (`${prefs.tempo.id}` === video.tempo) {
        score += 1;
      }
    }

    // durations
    if (video.videoDuration && prefs.duration) {
      const duration = parseInt(video.videoDuration, 10);
      if (prefs.duration.id === 1 && duration < 11) {
        score += 1;
      }
      if (prefs.duration.id === 2 && duration < 21 && duration > 10) {
        score += 1;
      }
      if (prefs.duration.id === 3 && duration < 41 && duration > 20) {
        score += 1;
      }
      if (prefs.duration.id === 4 && duration < 61 && duration > 40) {
        score += 1;
      }
      if (prefs.duration.id === 1 && duration > 60) {
        score += 1;
      }
    }

    return score;
  }
};
